import React from 'react';
import styles from './Form.module.css';

interface ColorPickerProps {
  label: string;
  value?: string | null;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
}

const normalizeHex = (val: string | null | undefined): string => {
  if (!val) return '';
  const v = val.trim();
  if (v.length === 0) return '';
  return v.startsWith('#') ? v : `#${v}`;
};

const ColorPicker: React.FC<ColorPickerProps> = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = '#193e6e',
  error
}) => {
  const hex = normalizeHex(value || '');

  return (
    <div className={styles.formGroup}>
      <label className={styles.formLabel}>
        {label}
        {required && <span className={styles.formRequired}>*</span>}
      </label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          type="color"
          value={hex || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          style={{ width: 40, height: 40, border: 'none', background: 'none', padding: 0 }}
        />
        <input
          type="text"
          value={value || ''}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={styles.formInput}
          style={{ flex: 1 }}
        />
      </div>
      {error && <p className={styles.formErrorMessage} role="alert">{error}</p>}
    </div>
  );
};

export default ColorPicker;


